import {Api} from "../../../../api/InternalApi";
import {ChooseFileStrategy} from "./ChooseFileStrategy";

export class ChooseLocalFileStrategy implements ChooseFileStrategy {

  constructor(private api: Api) {
  }

  pathSeparator = "\\";

  canInputNewDirectory = false;
  renderNewDirectoryInputLabel = (): JSX.Element => {
    throw new Error("Not implemented");
  }

  browse(rootPath: string) {
    return this.api.browse(rootPath);
  }
}